export default __webpack_public_path__ + "static/kokkaigijidomae-20190406-DSC02834-resize-w2000-506203aa9f578ec3e609640f85322236.jpg";